import { render, staticRenderFns } from "./PreviewAdCard.ts.vue?vue&type=template&id=7432ac7c&scoped=true"
import script from "./PreviewAdCard.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewAdCard.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PreviewAdCard.ts.vue?vue&type=style&index=0&id=7432ac7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7432ac7c",
  null
  
)

export default component.exports